import { render, staticRenderFns } from "./VrstePrometa.vue?vue&type=template&id=220cc1dd&scoped=true&"
import script from "./VrstePrometa.vue?vue&type=script&lang=js&"
export * from "./VrstePrometa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220cc1dd",
  null
  
)

export default component.exports